import { LayoutHOC } from 'base/ui/layout/layout';

import { ReminderRoutes } from './routes';
import createRemindList from './Warranty';
import createRemindSchedules from './RemindLists';
import createSetUpTimeWarranty from './SetUpTimeWarranty';

export const createReminderPage = (layoutHOC: LayoutHOC) => {
  const Warranty = createRemindList();
  const List = createRemindSchedules();
  const SetUpTime = createSetUpTimeWarranty();
  const ReminderPage = layoutHOC(ReminderRoutes);

  return () => <ReminderPage List={List} Warranty={Warranty} SetupTime={SetUpTime} />;
};
